import { CLOSE_DRAWER } from './constants';

export const closeMenu = isMenuClosed => ({
  type: CLOSE_DRAWER,
  payload: isMenuClosed
});